// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"fc850580","271":"d26eb1f6","417":"0a33a821","453":"106fd614","477":"672eaf73","647":"77af2bd3","704":"bbaacd10","729":"4e13e8fe","744":"52acbe4a","840":"16054e50","854":"128e2b05","956":"9286f4eb"}[chunkId] + ".chunk.js";
};